import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import styles from './FancyField.css';



const actions = {};

/** FancyField component description */
class FancyField extends Component {
    constructor(props) {
        super(props);

        this.xxx = props.xxx;
    }

    render() {
        // console.log (this.props.value, typeof(this.props.value))
        if (Number.isNaN(this.props.value) || this.props.value == undefined) {
            return <div className="FancyField" />;
        }

        return (<div className="FancyField">
            <label>{this.props.label}</label>
            <div className="valueContainer">
                {this.props.value}
            </div>
            {/* <div className="size">{this.props.value}</div> */}
            <svg className="graphic" preserveAspectRatio="none" viewBox="0 0 10 2">
                <rect x="-0.5" y="-0.5" width="10.5" height="2"/>
            </svg>
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
    // return Object.assign({}, { z: state.xxx }, ownProps);
}

FancyField.displayName = "FancyFieldComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(FancyField);
connectedComponent.displayName = "FancyField";


FancyField.propTypes = {

};

export default connectedComponent;
export { FancyField as FancyFieldComponent };